import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { setNotesAccordionOpenState } from '../actions/ui.actions';

export const NOTES_UI_FEATURE = 'notes_ui';

export interface NotesUiState {
    accordionOpenState: { [locationId: string]: { [accordionName: string]: boolean } };
}

export const initialUiState: NotesUiState = {
    accordionOpenState: {},
};

const _uiReducer = createReducer(
    initialUiState,
    on(setNotesAccordionOpenState, (state, { locationId, accordionName, isOpen }) => ({
        ...state,
        accordionOpenState: {
            ...state.accordionOpenState,
            [locationId]: {
                ...state.accordionOpenState[locationId],
                [accordionName]: isOpen,
            },
        },
    })),
);

export function uiReducer(state: NotesUiState | undefined, action: Action) {
    return _uiReducer(state, action);
}

export const selectUiState = createFeatureSelector<NotesUiState>(NOTES_UI_FEATURE);
export const selectAccordionOpenState = (locationId: string) =>
    createSelector(selectUiState, (state) => state.accordionOpenState[locationId] || {});
